export default function getDigitalFormatTypeString(formatName) {
  switch (formatName) {
    case 'VIDEO':
    case 'STREAMING_VIDEO':
      return 'video';
    case 'MUSIC':
    case 'MUSIC_ONLINE':
      return 'music';
    case 'OVERDRIVE_MP3_AUDIOBOOK':
    case 'OVERDRIVE_WMA_AUDIOBOOK':
      return 'audiobook';
    case 'OVERDRIVE_MEDIA_DO':
      return 'media_do';
    default:
      return 'ebook';
  }
}
